<template lang="html">
  <div class="menu">

    <nav class="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
      <div class="container">
        <div>
          <a class="navbar-brand" href="#home" @click="rota('Home')">
            <img :src="logo" height="60" id="logoTranquilandia" alt="Pousada Tranquilandia Village">
          </a>
          <a class="trip-advisor" target="_blank" href="https://www.tripadvisor.com.br/Hotel_Review-g635974-d1557902-Reviews-Pousada_Tranquilandia_Village-Canoa_Quebrada_State_of_Ceara.html">
            <img :src="tripAdvisor" alt="TripAdvisor" class="widCOEImg" id="CDSWIDCOELOGO"/>
          </a>
          <a href="#pets" @click="rota('Pets')">
            <img :src="petFriendly" alt="PetFriendly" height="60">
          </a>
        </div>

        <div>
          <!-- <button @click="rota('Contact')" class="navbar-toggler navbar-toggler-right btn-contact" type="button">
            <img src="../../assets/png/glyphicons-78-headset.png" alt="fale conosco" class="img-contact-us" style="filter: invert(100%)">
          </button> -->
          <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <button class="navbar-toggler navbar-toggler-right" type="button" style="border: none">
            <div class="dropdown dropleft">
              <button class="bg-color dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img :src="iconLanguage" class="menu-img-language" alt="">
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" @click="selectLanguage('pt_BR','brazil')" href="#"><img src="../../../static/icons/brazil.png" class="img-country" alt="Brazil"> Portuguese </a>
                <a class="dropdown-item" @click="selectLanguage('en','united-kingdom')" href="#"><img src="../../../static/icons/united-kingdom.png" class="img-country" alt="United Kingdom"> English</a>
                <a class="dropdown-item" @click="selectLanguage('fr','france')" href="#"><img src="../../../static/icons/france.png" class="img-country" alt="France"> French</a>
                <a class="dropdown-item" @click="selectLanguage('es','spain')" href="#"><img src="../../../static/icons/spain.png" class="img-country" alt="Spain"> Spanish</a>
                <a class="dropdown-item" @click="selectLanguage('it','italy')" href="#"><img src="../../../static/icons/italy.png" class="img-country" alt="Italy"> Italian</a>
              </div>
            </div>
          </button>
        </div>
        <div class="collapse navbar-collapse" id="navbarResponsive">
          <ul class="navbar-nav ml-auto">
            <div class="dropdown"  style="margin:0 auto;">
              <button style="display:block;margin:0 auto;" class="bg-color dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ $t('menu.a_pousada') }}
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" href="#home" @click="rota('Home')">{{ $t('menu.sobre_nos') }}</a>
                <a class="dropdown-item" href="#photos" @click="rota('Photo')">{{ $t('menu.fotos') }}</a>
                <a class="dropdown-item" href="#bedroom" @click="rota('Bedroom')">{{ $t('menu.quartos') }}</a>
                <a class="dropdown-item" href="#convenience" @click="rota('Convenience')">{{ $t('menu.comodidades') }}</a>
                <a class="dropdown-item" href="#restaurant" @click="rota('Restaurant')">{{ $t('menu.restaurante') }}</a>
                <a class="dropdown-item" href="#pets" @click="rota('Pets')">{{ $t('menu.animais') }}</a>
              </div>
            </div>

            <li class="nav-item">
              <a class="nav-link js-scroll-trigger" href="#canoa-quebrada" @click="rota('CanoaQuebrada')">{{ $t('menu.canoa_quebrada') }}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link js-scroll-trigger" href="#kite-surf" @click="rota('KiteSurf')">{{ $t('menu.kite_surf') }}</a>
            </li>
            <!-- botão de reserva com pipe -->
            <!-- <router-link tag="a" class="nav-item btn-reservation" :to="{ name: 'SelectDatesReservation' }">
              <a class="nav-link js-scroll-trigger" href="#reservation">
                {{ $t('menu.reservar_agora') }}
              </a>
              <div class="btn-reservation-desconto">
                {{$t('menu.com')}}<br/>10% OFF
              </div>
            </router-link> -->
            <!-- botão de reserva simplificado -->
            <router-link tag="a" class="nav-item btn-reservation" :to="{ name: 'SelectDatesReservation' }">
              <a class="nav-link js-scroll-trigger" href="#reservation">
                {{ $t('menu.reservar_agora') }}
              </a>
            </router-link>
            <div class="dropdown" v-show="textContact">
              <button class="bg-color dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img :src="iconLanguage" class="menu-img-language" alt="">
              </button>
              <div class="dropdown-menu" id="dropdown-menu-items" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" @click="selectLanguage('pt_BR','brazil')" href="#"><img src="../../../static/icons/brazil.png" class="img-country" alt="Brazil"> Portuguese </a>
                <a class="dropdown-item" @click="selectLanguage('en','united-kingdom')" href="#"><img src="../../../static/icons/united-kingdom.png" class="img-country" alt="United Kingdom"> English</a>
                <a class="dropdown-item" @click="selectLanguage('fr','france')" href="#"><img src="../../../static/icons/france.png" class="img-country" alt="France"> French</a>
                <a class="dropdown-item" @click="selectLanguage('es','spain')" href="#"><img src="../../../static/icons/spain.png" class="img-country" alt="Spain"> Spanish</a>
                <a class="dropdown-item" @click="selectLanguage('it','italy')" href="#"><img src="../../../static/icons/italy.png" class="img-country" alt="Italy"> Italian</a>
              </div>
            </div>
          </ul>
        </div>
      </div>
    </nav>

    <!-- <nav id="contact-us" class="fixed-top" v-show="textContact">
      <div class="host desktop" @click="rota('Contact')">
        <p>
          <img src="../../assets/png/glyphicons-78-headset.png" alt="fale conosco" class="img-contact-us">
          {{$t('fale_conosco.contato')}}
        </p>
      </div>
    </nav> -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      iconLanguage: require('../../../static/icons/brazil.png'),
      logo: require('../../assets/img/logo1.png'),
      tripAdvisor: require('../../assets/img/travell1.png'),
      petFriendly: require('../../assets/img/pet-friendly-white.png'),
      textContact: true
    }
  },

  created() {
    if(window.innerWidth < 992) {
      this.logo = require('../../assets/img/logo2.png')
      this.tripAdvisor = require('../../assets/img/travell2.png')
      this.petFriendly = require('../../assets/img/pet-friendly-black.png')
    } else {
      this.logo = require('../../assets/img/logo1.png')
      this.tripAdvisor = require('../../assets/img/travell1.png')
      this.petFriendly = require('../../assets/img/pet-friendly-white.png')
    }
  },

  mounted() {
    if(window.innerWidth < 992) {
      document.getElementById("CDSWIDCOELOGO").style.height = "50px"
      document.getElementById("logoTranquilandia").style.height = "50px"
      document.getElementById("logoTranquilandia").style.width = "80px"
    } else {
      document.getElementById("CDSWIDCOELOGO").style.height = "75px"
      document.getElementById("logoTranquilandia").style.height = "60px"
    }

    $('.js-scroll-trigger').click(function() {
      $('.navbar-collapse').collapse('hide');
    })

    // Activate scrollspy to add active class to navbar items on scroll
    $('body').scrollspy({
      target: '#mainNav',
      offset: 57
    })

    // Collapse Navbar
    var navbarCollapse = function() {
      if ($("#mainNav").offset().top > 70) {
        $("#mainNav").addClass("navbar-shrink")
      } else {
        $("#mainNav").removeClass("navbar-shrink")
      }
    };
    // Collapse now if page is not at top
    navbarCollapse();
    // Collapse the navbar when page is scrolled
    $(window).scroll(navbarCollapse);

    let menuFixed = () => {
      if (window.innerWidth > 991) {
        $("#mainNav").addClass("fixed-top")
        this.logo = require('../../assets/img/logo1.png')
        this.tripAdvisor = require('../../assets/img/travell1.png')
        this.petFriendly = require('../../assets/img/pet-friendly-white.png')
        this.textContact = true
      } else {
        $("#mainNav").removeClass("fixed-top")
        this.logo = require('../../assets/img/logo2.png')
        this.tripAdvisor = require('../../assets/img/travell2.png')
        this.petFriendly = require('../../assets/img/pet-friendly-black.png')
        this.textContact = false
      }
    };

    window.onresize = menuFixed
    window.onload = menuFixed
  },

  methods: {
    rota(route){
      this.$router.push({name: route});
    },

    selectLanguage(language, icon) {
      this.$i18n.locale = language
      this.$store.commit('selectLanguage', language)

      this.iconLanguage = require('../../../static/icons/' + icon + '.png')
    }
  },
}
</script>

<style lang="css">
/* ------------------------------------------- */
/* ------------ BOTÃO DE CONTATO ------------- */
/* ------------------------------------------- */
#contact-us {
	cursor: pointer;
}
#contact-us:HOVER p {
	font-weight: bold;
}
#contact-us .host {
	position: fixed;
	background-color: rgb(23, 162, 184);
	color: white;
	box-shadow: 0 0 10px #555;
	border-top-right-radius: 5px;
	border-bottom-right-radius: 5px;
	z-index: 100;
  margin-top: 100px
}
#contact-us .desktop {
	width: 170px;
}
#contact-us .desktop p {
	text-align: center;
	margin-top: 15px;
	transition: all 1s;
}
#contact-us .desktop p img {
	filter: invert(100%);
	margin-right: 10px;
}
.menu #mainNav .btn-contact {
  background-color: rgb(23, 162, 184)
}
/* -------------------------------------------- */
* .img-country {
  height: 20px;
  width: 20px;
}
* .menu-img-language {
  height: 25px;
  width: 25px;
}

#mainNav {
  /* border-bottom: 1px solid rgb(118, 106, 49); */
  background-color: rgba(255,255,255,.7);
  font-family: 'Open Sans', 'Helvetica Neue', Arial, sans-serif;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  transition: all 1s;
}

#mainNav .navbar-nav > li.nav-item > a.nav-link,
#mainNav .navbar-nav > li.nav-item > a.nav-link:focus {
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
}
#mainNav .navbar-nav > li.nav-item > a.nav-link:hover,
#mainNav .navbar-nav > li.nav-item > a.nav-link:focus:hover,
#mainNav .bg-color:hover {
  color: rgb(118, 106, 49);
}
#mainNav .navbar-nav > li.btn-reservation > a.nav-link:hover,
#mainNav .navbar-nav > li.btn-reservation > a.nav-link:focus:hover {
  color: rgb(0, 38, 62);
}

#mainNav .navbar-nav > li.nav-item > a.nav-link.active,
#mainNav .navbar-nav > li.nav-item > a.nav-link:focus.active,
#mainNav .bg-color.active,
#mainNav .bg-color:focus.active {
  background-color: transparent;
}

#mainNav .navbar-nav > li.nav-item > a.nav-link.active:hover,
#mainNav .navbar-nav > li.nav-item > a.nav-link:focus.active:hover,
#mainNav .bg-color.active:hover,
#mainNav .bg-color:focus.active:hover {
  background-color: transparent;
}
#mainNav .navbar-nav > a.btn-reservation a.nav-link {
  color: rgba(255, 255, 255, 0.7);
  padding: 0;
  padding-right: 5px;
  /* border-right: 2px solid rgba(255, 255, 255, 0.7); */
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
}

@media (min-width: 992px) {
  #mainNav {
    border-color: rgb(118, 106, 49);
    background-color: rgba(0, 0, 0, .4);
  }
  #mainNav .navbar-nav > li.nav-item > a.nav-link,
  #mainNav .bg-color {
    padding: 5px 8px;
  }
  #mainNav .navbar-nav > li.nav-item > a.nav-link,
  #mainNav .navbar-nav > li.nav-item > a.nav-link:focus,
  #mainNav .bg-color,
  #mainNav .bg-color:focus {
    color: rgba(255, 255, 255, 0.7);
  }

  #mainNav .navbar-nav > li.nav-item > a.nav-link:hover,
  #mainNav .navbar-nav > li.nav-item > a.nav-link:focus:hover,
  #mainNav .bg-color:hover,
  #mainNav .bg-color:focus:hover {
    color: rgb(118, 106, 49);
  }
  #mainNav .navbar-nav > li.btn-reservation > a.nav-link:hover,
  #mainNav .navbar-nav > li.btn-reservation > a.nav-link:focus:hover {
    color: rgb(0, 38, 62);
  }
  #mainNav.navbar-shrink {
    /* border-bottom: 3px solid rgb(118, 106, 49); */
    background-color: rgba(0,0,0,.7);
  }
  #mainNav.navbar-shrink .navbar-brand {
    color: white;
  }
  .menu .navbar .trip-advisor {
    margin-right: 1rem;
  }
  .tripAdvisor2020 {
    margin-right: 1rem;
  }
  #mainNav.navbar-shrink .navbar-nav > li.nav-item > a.nav-link,
  #mainNav.navbar-shrink .navbar-nav > li.nav-item > a.nav-link:focus,
  #mainNav.navbar-shrink .navbar-nav .bg-color,
  #mainNav.navbar-shrink .navbar-nav .bg-color:focus {
    color: white;
  }
  #mainNav.navbar-shrink .navbar-nav > li.nav-item > a.nav-link:hover,
  #mainNav.navbar-shrink .navbar-nav > li.nav-item > a.nav-link:focus:hover,
  #mainNav.navbar-shrink .navbar-nav .bg-color:hover,
  #mainNav.navbar-shrink .navbar-nav .bg-color:focus:hover {
    color: rgb(118, 106, 49);
  }
  #mainNav.navbar-shrink .navbar-nav > li.btn-reservation > a.nav-link:hover,
  #mainNav.navbar-shrink .navbar-nav > li.btn-reservation > a.nav-link:focus:hover {
    color: rgb(0, 38, 62);
  }
}

.dropdown {
  margin-left: -5px
}
.dropdown button {
  color: rgba(0,0,0,.5);
}
#mainNav .bg-color,
.dropdown-menu .dropdown-item {
  cursor: pointer;
  background-color: rgba(255,255,255,0);
  border: none;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  font-family: 'Open Sans', 'Helvetica Neue', Arial, sans-serif;
}
#dropdown-menu-items {
  margin-left: -80px;
}
.bg-color,
.bg-color:focus {
  outline: inherit;
}
.dropdown-menu .dropdown-item {
  color: black;
}
.dropdown-menu .dropdown-item:hover {
  color: rgb(118, 106, 49);
}
.btn-reservation {
  background-color: rgb(23, 162, 184);
  border-radius: 3px;
  padding-left: 5px;
  margin: 2px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}
.btn-reservation:hover {
  text-decoration: none;
}
.btn-reservation .btn-reservation-desconto {
  color: rgba(255, 255, 255, 0.7);
  text-align:center;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  padding-left:5px;
  line-height: 1
}
</style>



// WEBPACK FOOTER //
// src/components/menu/Menu.vue